import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../services/briefConfigService";
import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";
import { IRenameBriefConfigDeliverableRequest } from "@shared/lib/types/briefConfig";
import { ToastService } from "@shared/lib/services";

export function useRenameBriefConfigDeliverable(briefId: string) {
  const {
    mutate: renameDeliverable,
    isLoading: isRenaming,
    isSuccess: isRenamed,
  } = useMutation({
    mutationFn: ({ data }: { data: IRenameBriefConfigDeliverableRequest }) =>
      BriefConfigService.renameBriefConfigDeliverable(data).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: BRIEF_CONFIG_QUERY_KEY(briefId) });
    },
  });

  return {
    renameDeliverable,
    isRenaming,
    isRenamed,
  };
}
